import { useLocation, useNavigate } from 'react-router-dom';

const PACAA020 = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { username, password } = location.state || {};

    const handleIntegrated = () => {
        if (window.confirm('통합 회원로 전환하시겠습니까?')) {
            navigate('/padaa010?integrated=true', { state: { username, password } });
        }
    };
    return (
        <div id="content">
            <div id="after-successful-login">
                <div className="container">
                    <div className="titleText">로그인</div>
                    <div className="titleContent">통합 ID 전환</div>
                    <div className="header-content">
                        <p className="header-content-child-1">
                            하나의 단일한 아이디로
                            <br />
                            덴탈잡, 덴탈비타민, 덴탈세미나, DVmall 사이트를
                            <br />
                            모두 이용할 수 있습니다.
                        </p>
                        <p className="header-content-child-2">
                            통합완료 후 덴탈잡 이용시 추가적으로 조회권한 비밀번호를
                            <br /> 설정해서 보안을 강화할 수 있습니다.
                        </p>
                        <button className="button-header-content" onClick={handleIntegrated}>
                            통합 ID로 전환하기
                        </button>
                    </div>
                    <img className="poster-introduction" src="./images/PACAA020/poster-introduction.jpg" alt="" />
                </div>
            </div>
        </div>
    );
};

export default PACAA020;
